import type { EnabledCurrencies, PriceRates } from '../../types'
import { currencyDecimalPlaces } from './providers/TierProvider/consts'

export const getExchangeRate = (currency: EnabledCurrencies[number], rates: PriceRates) => {
  const priceRatesIndex = currency.toLowerCase() as Exclude<
    Lowercase<typeof currency>,
    'inr' | 'brl'
  >

  const exchangeRate = rates[priceRatesIndex].amount / 10 ** currencyDecimalPlaces[priceRatesIndex]

  return exchangeRate
}
